import React from "react";
import { DepartmentForm } from "./Forms/DepartmentForm";
import { useCreateDepartmentMutation } from "../../services/basicData/basicData";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Container, Form, Spinner } from "reactstrap";
import { Stack } from "react-bootstrap";

export const CreateDepartment = () => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: {
      name_ar: "",
      name_en: "",
    },
  });

  const { mutate: createDepartment, isPending } =
    useCreateDepartmentMutation(setError);
  const { t } = useTranslation();

  const onSubmit = (data) => {
    createDepartment(data);
  };

  return (
    <Stack gap={2}>
      <PageHeader title={t("CREATE_DEPARTMENT")} />
      <Container fluid>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <DepartmentForm control={control} errors={errors} />
          <Button variant="primary" type="submit" disabled={isPending}>
            {isPending ? (
              <>
                <Spinner size="sm" />
                {t("CREATING_DEPARTMENT")}
              </>
            ) : (
              t("CREATE_DEPARTMENT")
            )}
          </Button>
        </Form>
      </Container>
    </Stack>
  );
};
